import api from './api';

export const fetchContasPagar = async () => {
  const res = await api.get('/contas-pagar');
  // retorna array como nos mocks
  return res.data && res.data.data ? res.data.data : [];
};

export const fetchContasPagarStats = async () => {
  const res = await api.get('/contas-pagar/stats');
  return res.data && res.data.data ? res.data.data : {};
};

export const getContaPagarById = async (id) => {
  const res = await api.get(`/contas-pagar/${id}`);
  return res.data && res.data.data ? res.data.data : null;
};

export const createContaPagar = async (data) => {
  const res = await api.post('/contas-pagar', data);
  return res.data && res.data.data ? res.data.data : null;
};

export const updateContaPagar = async (id, data) => {
  const res = await api.put(`/contas-pagar/${id}`, data);
  return res.data && res.data.data ? res.data.data : null;
};

export const baixarContaPagar = async (id, dataPagamento, baixadoPor) => {
  const body = { dataPagamento, baixadoPor };
  const res = await api.patch(`/contas-pagar/${id}/baixar`, body);
  return res.data && res.data.data ? res.data.data : null;
};

export const removeContaPagar = async (id) => {
  const res = await api.delete(`/contas-pagar/${id}`);
  return res.data && res.data.success;
};

const contaPagarService = {
  fetchContasPagar,
  fetchContasPagarStats,
  getContaPagarById,
  createContaPagar,
  updateContaPagar,
  baixarContaPagar,
  removeContaPagar
};

export default contaPagarService;
